import ExpertProfileViewModalModule from './expert-profile-view-modal.module'

export default ExpertProfileViewModalModule
